import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Badge, Card, Modal, Button } from "react-bootstrap";
import { FaUsers, FaArrowRight, FaFileInvoiceDollar } from "react-icons/fa";

function BasicExample() {
  const [tipoCliData, setTipoCliData] = useState([]);
  const [allData, setAllData] = useState([]); // Database completo per il dettaglio
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        const localita = res.data.TP.localita || [];
        setAllData(localita);

        // AGGREGAZIONE: Somma Valore e Numero Doc per tipo_cliente
        const aggregation = localita.reduce((acc, item) => {
          const tipo = item.tipo_cliente || "N/D";
          const valore = parseFloat(item.Valore || 0);
          const numDoc = parseInt(item.numero_doc || 0);

          if (!acc[tipo]) {
            acc[tipo] = {
              tipo_cliente: tipo,
              totaleValore: 0,
              totaleDoc: 0,
            };
          }
          acc[tipo].totaleValore += valore;
          acc[tipo].totaleDoc += numDoc;
          return acc;
        }, {});

        const transformedData = Object.values(aggregation);
        // Ordina per valore decrescente
        setTipoCliData(
          transformedData.sort((a, b) => b.totaleValore - a.totaleValore),
        );
      } catch (err) {
        console.error("Errore caricamento localita:", err);
      }
    };
    fetchData();
  }, []);

  const handleRowClick = (categoria) => {
    setSelectedCategory(categoria);
    setShowModal(true);
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount || 0);

  // Filtra i dettagli per il modale
  const modalDetails = allData.filter(
    (item) => item.tipo_cliente === selectedCategory,
  );

  return (
    <>
      <Card
        className="card ombra card-home border-0"
        style={{ borderRadius: "15px", padding: "1.2rem" }}
      >
       

        <div
          className="no-scrollbar"
          style={{ height: 350, overflowY: "auto" }}
        >
          <Table hover responsive className="mb-0 custom-table" style={{
              fontSize: "0.75rem",
              width: "100%",
              minWidth: "700px", // FORZA LA LARGHEZZA MINIMA PER EVITARE COLLASSI
              margin: 0,
              borderCollapse: "separate",
            }}>
            
            <thead className="sticky-top bg-white" style={{ zIndex: 10 }}>
              <tr
                className="text-muted small"
                style={{ borderBottom: "2px solid #f1f1f1" }}
              >
                <th style={{ width: "30%" }} className="ps-4 py-3 border-0">
                  TIPO CLIENTE
                </th>
                <th
                  style={{ width: "30%" }}
                  className="py-3 border-0 text-end cursor-pointer"
                >
                  VALORE TOTALE
                </th>
                <th
                  style={{ width: "30%" }}
                  className="py-3 border-0 text-end cursor-pointer"
                >
                  DOC
                </th>
              
              </tr>
            </thead>
            <tbody>
              {tipoCliData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(item.tipo_cliente)}
                  style={{ cursor: "pointer" }}
                  className="align-middle"
                >
                  <td className="fw-bold ps-3">{item.tipo_cliente}</td>
                  <td className="text-end fw-bold text-danger">
                    {formatToEuro(item.totaleValore)}
                  </td>
                  <td className="text-end">
                    <Badge bg="secondary" pill style={{ fontSize: "0.7rem" }}>
                      {item.totaleDoc}
                    </Badge>
                  </td>
                 
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* MODAL DETTAGLIO CLIENTI PER CATEGORIA */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        scrollable
        dialogClassName="custom-modal-center"
      >
        <Modal.Header closeButton className="border-0 bg-light">
          <Modal.Title className="fw-bold h5">
            Clienti Categoria:{" "}
            <span className="text-title">{selectedCategory}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <Table  hover responsive className="mb-0">
            <thead className="bg-white sticky-top">
              <tr className="small text-muted shadow-sm">
                <th className="ps-4 py-3">RAGIONE SOCIALE</th>
                <th className="py-3">LOCALITÀ</th>
                <th className="text-end py-3">VALORE</th>
                <th className="text-center py-3 pe-4">DOC</th>
              </tr>
            </thead>
            <tbody>
              {modalDetails.map((client, i) => (
                <tr key={i} className="align-middle">
                  <td className="ps-4 py-3 fw-bold small text-uppercase">
                    {client.clienti}
                  </td>
                  <td className="small text-muted">{client.paese}</td>
                  <td className="text-end fw-bold text-danger">
                    {formatToEuro(parseFloat(client.Valore))}
                  </td>
                  <td className="text-center pe-4">
                    <span className="badge rounded-pill bg-light text-dark border">
                      {client.numero_doc}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>

      <style>{`
        .custom-table tbody tr:hover { background-color: rgba(13, 110, 253, 0.05) !important; }
        .text-title { letter-spacing: 0.5px; color: #2c3e50; }
        .ombra { box-shadow: 0 8px 30px rgba(0,0,0,0.05); }
        .no-scrollbar::-webkit-scrollbar { width: 5px; }
        .no-scrollbar::-webkit-scrollbar-thumb { background: #dee2e6; border-radius: 10px; }
        .sticky-top { z-index: 1020; }
      `}</style>
    </>
  );
}

export default BasicExample;
